import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import TeamForm from "../form";

const UpdateTeam = () => {
  const { teamId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Team" />
      <div className="p-6 max-w-2xl">
        <TeamForm teamId={teamId} />
      </div>
    </div>
  );
};

export default UpdateTeam;
